module.exports = __webpack_public_path__ + "static/media/ic_input_65.f1d04b2c.svg";